import { NgFor, NgIf } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TagDto } from '@picflow/types';
import { catchError, of, tap, throwError } from 'rxjs';
import { tagColors } from 'src/app/consts';
import { DialogOptions } from 'src/app/interfaces/dialog-data.interface';
import { DialogService, OnGetData } from 'src/app/services/dialog.service';
import { FeatureFlagsService } from 'src/app/services/feature-flags.service';
import { ToastService } from 'src/app/services/toast.service';
import { InputFieldComponent } from 'src/app/shared-extra/components/input-field/input-field.component';
import { SvgComponent } from 'src/app/shared/components/svg/svg.component';
import { ButtonDirective } from 'src/app/shared/directives/button.directive';
import { TagService } from 'src/app/tag.service';
import { DeleteTagDialogComponent } from '../delete-tag-dialog/delete-tag-dialog.component';

@Component({
  selector: 'app-edit-tag-dialog',
  standalone: true,
  imports: [SvgComponent, ButtonDirective, FormsModule, ReactiveFormsModule, InputFieldComponent, NgIf, NgFor],
  templateUrl: './edit-tag-dialog.component.html',
  styleUrls: ['./edit-tag-dialog.component.scss'],
})
export class EditTagDialogComponent implements OnGetData {
  dialogName = 'edit-tag';
  close: (tag: 'deleted' | null) => void;
  tag: TagDto;
  colors = tagColors;
  newColor: string;
  form = new FormGroup({
    name: new FormControl('', [Validators.required]),
  });

  dialogOptions(): DialogOptions {
    return { hasSmallBottomPart: true };
  }

  constructor(
    private tagService: TagService,
    private toats: ToastService,
    private dialog: DialogService,
    public featureFlags: FeatureFlagsService
  ) {}

  onGetData(data: { tag: TagDto }, close: () => void) {
    this.tag = data.tag;
    this.close = close;
    this.form.setValue({ name: this.tag.name });
    this.newColor = this.tag.color;
  }

  save() {
    if (!this.form.valid) return;
    return this.tagService
      .updateTag(this.tag.id, {
        name: this.form.value.name,
        color: this.newColor,
      })
      .pipe(
        tap(() => {
          this.toats.add('Tag updated', 'success');
          this.close(null);
        }),
        catchError(err => {
          if (!(err instanceof HttpErrorResponse)) return throwError(() => err);

          if (err.error?.code === 'tag_exists') {
            this.toats.add('A Tag with that name already exists', 'error');
            return of(undefined);
          }

          return throwError(() => err);
        })
      )
      .subscribe();
  }

  deleteTag() {
    this.dialog.open(DeleteTagDialogComponent, { tag: this.tag });
  }
}
